module.exports = __webpack_public_path__ + "static/media/pin-success-privado.3ab44ad4.png";